import React from "react";
import PropTypes from "prop-types";

import Link from "core/Link";
import Hidden from "core/Hidden";
import BodyText from "core/BodyText";
import Doc from "core/ReusableIcons/Doc";
import Checkmark from "core/ReusableIcons/Checkmark";
import Avatar from "core/Avatar";
import colors from "core/colors";
import {
    IconWrapper,
    Detail,
    Wrapper,
    DetailWrapper,
    CapitalizeOnSmBreakpoint
} from "./styles";

const InfoBar = ({ creator, type }) => {
    const isOnCheckoutPage = type === "icons";

    return (
        <Wrapper
            fullWidth
            topSpacing="xl"
            bottomSpacing="none"
            bgColor={colors.functional.secondary.tulle}
        >
            <DetailWrapper
                flexWrap="wrap"
                inlineFlex
                justifyContent="space-between"
            >
                <Detail alignItems="center">
                    <Avatar src={creator.avatarUrl} width="1.5rem" alt="" />
                    <BodyText
                        type="p"
                        size="md"
                        copyColor={colors.primary.diamond}
                    >
                        <Hidden type="span" breakpoint="sm">
                            Your{" "}
                        </Hidden>
                        <CapitalizeOnSmBreakpoint>
                            purchase
                        </CapitalizeOnSmBreakpoint>{" "}
                        supports{" "}
                        <Link href={`/${creator.username}/`} size="md" darkMode>
                            {creator.name}
                        </Link>
                    </BodyText>
                </Detail>

                <Detail alignItems="center">
                    <IconWrapper>
                        <Checkmark
                            fillColor={colors.primary.diamond}
                            size="md"
                        />
                    </IconWrapper>
                    <BodyText
                        type="p"
                        size="md"
                        copyColor={colors.primary.diamond}
                    >
                        No attribution required
                    </BodyText>
                </Detail>

                {isOnCheckoutPage && (
                    <Detail alignItems="center">
                        <IconWrapper>
                            <Doc fillColor={colors.primary.diamond} size="md" />
                        </IconWrapper>
                        <BodyText
                            type="p"
                            size="md"
                            copyColor={colors.primary.diamond}
                        >
                            Royalty-free license
                        </BodyText>
                    </Detail>
                )}
            </DetailWrapper>
        </Wrapper>
    );
};

InfoBar.propTypes = {
    creator: PropTypes.shape({
        avatarUrl: PropTypes.string,
        username: PropTypes.string,
        name: PropTypes.string
    }).isRequired,
    type: PropTypes.oneOf(["icons", "photos"])
};

export default InfoBar;
